import { BaseElement, ClickElement } from './base-element';
import { ElementType } from './element-type';
import { Layout } from './layout';

export class Table extends BaseElement {
  headers: Header[] = [];
  rows: Row[] = [];

  constructor() {
    super();
    this.elementType = ElementType.table;
  }
}

export interface Header {
  layout: Layout;
  value: string;
}

export interface Datum extends BaseElement {
  value: string;
  content: BaseElement[];
  layout: Layout;
}

export interface Row extends ClickElement {
  data: Datum[];
}
